/**
 * Action creators
 */
const actions = {
  setHeaderState: (data) => ({ type: 'SET_HEADER_STATE', data }),
};

/**
 * Set discovery data
 */
export const setHeaderState = (data) => (dispatch) => dispatch(actions.setHeaderState(data));
